import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, filter, debounceTime, catchError, tap, switchMap } from 'rxjs/operators';
// import{AppConfigService} from '../app-config.service';
// import { AppError } from '../common/class/app-error';
import *  as  connections from '../../assets/connections.json';
import { DestinationDetails } from 'src/app/class/DestinationDetails';
import { AutoLockRequestModel } from 'src/app/class/AutoLockRequestModel';
import { AppConfigService } from 'src/app/app-config.service';
import { AppError } from 'src/app/common/class/app-error';
import { AutoLockApiResponse, ResultContent } from 'src/app/class/AutoLockApiResponse';
import { SendAccessControlNoticeRequestModel,SendAccessControlNoticeRequestv2 ,SendAccessControlNoticeResult,SendAccessControlNoticeResponse} from 'src/app/class/SendAccessControlNoticeRequestModel';
import { AutoLockRequestDecisionModel, AutoLockDecisionResponse } from 'src/app/class/AutoLockAccess';
import { BotCheckRequest, ResultContentData, BotApiResponse } from 'src/app/class/BotCheckRequest';
import { MailContextRequest, MailContextResponse } from 'src/app/class/MailContextRequest ';

@Injectable({
  providedIn: 'root'
})
export class AI_AutoLock_Access_Check {
  ActAPIbaseUrl: string;
  WebAPIv2Url: string;
  baseUrl: string;
  OpenDetectionUrl: string;
  destinationDetailsUrl = 'api/LargemailDownload/DestinationDetails/{shortURL}?IpAddress={IpAddress}&feature={feature}';
  accessControlUrl = 'api/v1/AccessControl';
  deviceFingerPrintUrl = 'api/v1/activitytracking/DFPD';
  sendAccessControlNoticeUrl = 'api/v1/autolock/sendaccesscontrolnotice/';
  ServerVariablesUrl = 'api/v1/ServerVariables';
  GetRequestDecisionUrl = 'api/v1/autolock/GetRequestDecision';
  BotCheckRoute = 'api/v1/BCK';
  private readonly mailContextUrl = 'api/v1/mail/context';
  SendAccessControlNoticeRoute = 'api/v2/autolock/sendaccesscontrolnotice';
  //WebAPIv2Url = 'http://localhost:8087/';
  constructor(private http: HttpClient, private config: AppConfigService) {
    this.baseUrl = this.config.baseApiUrl;
    this.ActAPIbaseUrl = this.config.actAPIUrl;
    this.WebAPIv2Url = this.config.webAPIv2Url;
    this.OpenDetectionUrl = this.config.openDetectionUrl;
  }

  getDestinationDetails(shortUrl: string, IpAddress: string, feature: string): Observable<DestinationDetails> {
    const url = `${this.baseUrl}${this.destinationDetailsUrl.replace('{shortURL}', shortUrl).replace('{IpAddress}', IpAddress).replace('{feature}', feature)}`;
    return this.http.get<DestinationDetails>(url).pipe(
      catchError(err => {
        console.error('Error during getDestinationDetails', err);
        return of(null);
      })
    );
  }

  // Fetch Server Variables
  getServerVariables(): Observable<{ IPAddress: string, UserAgent: string, Referer: string, BrowserLanguage: string }> {
    const url = `${this.baseUrl}${this.ServerVariablesUrl}`;
    return this.http.get<{ Status: string, StatusCode: number, StatusText: string, Message: any[], ResultContent: { IPAddress: string, UserAgent: string, Referer: string, BrowserLanguage: string } }>(url).pipe(
      map(response => response.ResultContent),
      catchError(err => {
        console.error('Error during getServerVariables', err);
        return of(null);
      })
    );
  }

  getautoLockAccess(autoLockRequestModel: AutoLockRequestModel): Observable<AutoLockApiResponse> {
    const url = `${this.ActAPIbaseUrl}${this.accessControlUrl}`;
    return this.http.post<AutoLockApiResponse>(url, JSON.stringify(autoLockRequestModel), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).pipe(
      catchError(err => {
        console.error('Error during getautoLockAccess', err);
        return of(null);
      })
    );
  }


  sendAccessControlNotice(sendAccessControlNoticeRequestModel: SendAccessControlNoticeRequestModel): Observable<any> {
    const url = `${this.WebAPIv2Url}${this.sendAccessControlNoticeUrl}`;
    return this.http.post(url, JSON.stringify(sendAccessControlNoticeRequestModel), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).pipe(
      catchError(this.handleError)
    );
  }

  getMailContext(request: MailContextRequest): Observable<MailContextResponse> {
    const url = `${this.WebAPIv2Url}${this.mailContextUrl}`;

    return this.http.post<MailContextResponse>(url, request, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  GetRequestDecision(autoLockRequestDecisionModel: AutoLockRequestDecisionModel): Observable<AutoLockDecisionResponse> {
    const url = `${this.WebAPIv2Url}${this.GetRequestDecisionUrl}`;
    return this.http.post<AutoLockDecisionResponse>(url, JSON.stringify(autoLockRequestDecisionModel), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).pipe(
      catchError(err => {
        console.error('Error during AutoLockDecisionResultContent', err);
        return of(null);
      })
    );
  }

  triggerOpenDetection(shortUrl: string, website: string, deviceLogId: string): Observable<boolean> {
    const formattedUrl = `${shortUrl}.gif?website=${website}&deviceLogId=${deviceLogId}`;
    const url = `${this.OpenDetectionUrl}${formattedUrl}`;

    return this.http.get(url, { responseType: 'blob' }).pipe(
      map(() => true),
      catchError(err => {
        console.error('Error calling OpenDetection URL:', err);
        return of(false);
      })
    );
  }

  saveFingerprintDetails(deviceLogId: string, encryptedFingerprint: string): Observable<boolean> {
    const model = { DFPDLogId: deviceLogId, encryptedFP: encryptedFingerprint };
    const url = `${this.ActAPIbaseUrl}${this.deviceFingerPrintUrl}`;

    return this.http.post(url, JSON.stringify(model), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).pipe(
      map(() => true),
      catchError(err => {
        // console.error('Error saving fingerprint details:', err);
        return of(false);
      })
    );
  }

  botCheck(model: BotCheckRequest): Observable<ResultContentData | null> {
    const url = `${this.ActAPIbaseUrl}${this.BotCheckRoute}`;

    return this.http.post<BotApiResponse>(url, model).pipe(
      map(response => response.resultContent),
      catchError(err => {
        console.error('Error during BotCheck', err);
        return of(null);
      })
    );
  }

  sendAccessControlNoticeV2( model: SendAccessControlNoticeRequestv2 ): Observable<SendAccessControlNoticeResult | null> {
    const url = `${this.WebAPIv2Url}${this.SendAccessControlNoticeRoute}`;

    return this.http
      .post<SendAccessControlNoticeResponse>(url, model)
      .pipe(
        map(response => response.resultContent),
        catchError(err => {
          console.error('Error during SendAccessControlNotice', err);
          return of(null);
        })
      );
  }

  private handleError(err: HttpErrorResponse): Observable<AppError> {
    if (err != undefined) {
      const appError = new AppError(err);
      const errorStatus = err.status;
      const errorStatusText = err.statusText;
      const error: any = err.error;
      let errorMsg = '';

      if (error.Message !== undefined && Array.isArray(error.Message)) {
        errorMsg = err.error.Message[0].Message;
      } else {
        if (error.error_description) {
          errorMsg = error.error_description;
        } else {
          if (error.Message) {
            errorMsg = error.Message;
          } else {
            errorMsg = errorStatusText;
          }
        }
      }

      const retMsg = `Error (${errorStatus}): ${errorMsg}`;
      appError.Message = retMsg;

      return of(appError);
    }

  }

}

